const mapSections = document.querySelectorAll('.map-section');
const mapButtons = document.querySelectorAll('.map-button');
let lastClickedButton = null; // Track the last clicked button

if (mapButtons && mapSections) {
    mapSections.forEach((section) => (section.style.display = 'block'));

    mapButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            const sectionId = btn.getAttribute('data-section');
            const relatedSection = document.getElementById('map-' + sectionId);

            if (btn === lastClickedButton) {
                // If the same button is clicked again, reset everything
                mapSections.forEach((section) => (section.style.display = 'block'));
                if (lastClickedButton) {
                    lastClickedButton.classList.remove('active'); // Remove active class from the button
                }
                lastClickedButton = null;
            } else {
                // Hide all sections and show only the related one
                mapSections.forEach((section) => (section.style.display = 'none'));
                relatedSection.style.display = 'block';
                if (lastClickedButton) {
                    lastClickedButton.classList.remove('active'); // Remove active class from the previous button
                }
                btn.classList.add('active'); // Add active class to the current button
                lastClickedButton = btn;
            }

            window.scrollTo(0, 0);
        });
    });
}
